// Keep every free CTA on a page connected to its existing uploader/session.
export function openGuestFilePicker(event) {
  if (typeof document === 'undefined') return false;
  const entry = document.getElementById('try-transcription');
  const choose = entry?.querySelector('[data-guest-file-picker]');
  const url = entry?.querySelector('input[type="url"]');
  if (!choose && !url) return false;
  event?.preventDefault();
  entry.scrollIntoView({ block: 'start' });
  if (choose) choose.click();
  else url.focus({ preventScroll: true });
  return true;
}
